"use client";

import { Box, Container, Skeleton, SimpleGrid, VStack } from "@chakra-ui/react";

export function PricingPageSkeleton() {
  return (
    <Box minH="100dvh" bg="neutral.50">
      <Skeleton height="64px" width="full" />
      <Container maxW="9xl" py={12} px={6}>
        <VStack gap={6} mb={10} align="center">
          <Skeleton height="12px" width="140px" borderRadius="full" />
          <Skeleton height="48px" width="min(360px, 80%)" borderRadius="lg" />
          <Skeleton height="40px" width="240px" borderRadius="full" />
        </VStack>
        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap={5}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} height="480px" borderRadius="2xl" />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
